/**
 * reservation-cart-guard.js
 *
 * 「ライブ予約販売」コレクションの商品(コラボライブ/予約決済)と
 * それ以外の通常商品(日本ライブ/即時決済)が同時にカートへ入ることを防ぐ。
 *
 * 【設置場所】/assets/reservation-cart-guard.js としてテーマにアップロードし、
 * layout/theme.liquid の </body> 直前(reservation-cart-guard-data.liquid の後)に追加:
 *   {{ 'reservation-cart-guard.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  var CONFIG = window.reservationCartGuard || {};
  var RESERVATION_PRODUCT_IDS = new Set((CONFIG.productIds || []).map(String));
  var RESERVATION_VARIANT_IDS = new Set((CONFIG.variantIds || []).map(String));

  var WARNING_MESSAGE =
    'コラボライブ(予約販売)商品と日本ライブ商品は同時にカートに入れることができません。' +
    'お手数ですが、それぞれ別々にご注文手続きをお願いいたします。';

  function isReservationVariant(variantId) {
    return RESERVATION_VARIANT_IDS.has(String(variantId));
  }

  function isReservationProductId(productId) {
    return RESERVATION_PRODUCT_IDS.has(String(productId));
  }

  function showWarning(message) {
    var banner = document.getElementById('reservation-cart-guard-banner');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'reservation-cart-guard-banner';
      banner.setAttribute('role', 'alert');
      banner.style.cssText =
        'position:fixed;top:20px;left:50%;transform:translateX(-50%);' +
        'background:#fef2f2;border:1px solid #f87171;color:#991b1b;' +
        'padding:14px 20px;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,.15);' +
        'z-index:99999;max-width:92%;font-size:14px;line-height:1.6;text-align:center;';
      document.body.appendChild(banner);
    }
    banner.textContent = message;
    banner.style.display = 'block';
    window.clearTimeout(banner._hideTimer);
    banner._hideTimer = window.setTimeout(function () {
      banner.style.display = 'none';
    }, 6000);
  }

  // 現在のカート内容から「予約販売あり」「通常あり」を判定
  function getCartState() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var hasReservation = false;
        var hasNormal = false;
        (cart.items || []).forEach(function (item) {
          if (isReservationProductId(item.product_id) || isReservationVariant(item.variant_id)) {
            hasReservation = true;
          } else {
            hasNormal = true;
          }
        });
        return { hasReservation: hasReservation, hasNormal: hasNormal };
      });
  }

  // これから追加しようとしている variantId 配列が、既存カートと混在を起こすか判定
  function willCauseMix(addingVariantIds) {
    return getCartState().then(function (state) {
      var addingReservation = addingVariantIds.some(isReservationVariant);
      var addingNormal = addingVariantIds.some(function (id) {
        return !isReservationVariant(id);
      });
      var finalHasReservation = state.hasReservation || addingReservation;
      var finalHasNormal = state.hasNormal || addingNormal;
      return finalHasReservation && finalHasNormal;
    });
  }

  // --- 1) 通常のフォーム送信(<form action="/cart/add">)を横取り ---
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;

      var variantId = idInput.value;

      e.preventDefault();
      e.stopImmediatePropagation();

      willCauseMix([variantId]).then(function (blocked) {
        if (blocked) {
          showWarning(WARNING_MESSAGE);
        } else {
          // ブロック対象でなければ通常どおりネイティブ送信
          HTMLFormElement.prototype.submit.call(form);
        }
      });
    },
    true // capture phase: テーマ自身のイベントリスナーより先に処理する
  );

  // --- 2) fetch経由のAJAXカート追加(Dawn等の標準テーマ)を横取り ---
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;

    if (url && url.indexOf('/cart/add') !== -1 && init && init.body) {
      var variantIds = [];
      try {
        if (init.body instanceof FormData) {
          var singleId = init.body.get('id');
          if (singleId) variantIds.push(singleId);
          var itemsRaw = init.body.get('items');
          if (itemsRaw) {
            JSON.parse(itemsRaw).forEach(function (i) {
              variantIds.push(i.id);
            });
          }
        } else if (typeof init.body === 'string') {
          var parsed = JSON.parse(init.body);
          if (parsed.id) variantIds.push(parsed.id);
          if (parsed.items) {
            parsed.items.forEach(function (i) {
              variantIds.push(i.id);
            });
          }
        }
      } catch (err) {
        // パースできない形式のリクエストはガード対象外とし、素通りさせる
        variantIds = [];
      }

      if (variantIds.length) {
        return willCauseMix(variantIds).then(function (blocked) {
          if (blocked) {
            showWarning(WARNING_MESSAGE);
            return Promise.reject(new Error('reservation-cart-guard: blocked mixed cart'));
          }
          return originalFetch.apply(window, [input, init]);
        });
      }
    }

    return originalFetch.apply(window, arguments);
  };
})();